import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function AuthLayout({ title, subtitle, children }) {
  return (
    <div className="min-h-screen bg-nm-bg nm-grain font-sans flex flex-col">
      <div className="px-6 py-6">
        <Link to="/" className="inline-block leading-none" data-testid="auth-logo">
          <div className="text-[10px] font-semibold uppercase tracking-[0.22em] text-nm-coral">Manage(Meant) Excellence</div>
          <div className="font-serif text-lg text-nm-primary">The Manager Operating System</div>
        </Link>
      </div>
      <div className="flex-1 flex items-center justify-center px-6 pb-16">
        <motion.div initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.45, ease: "easeOut" }}
          className="w-full max-w-md rounded-3xl border border-nm-primary/10 bg-nm-surface p-8 sm:p-10 nm-shadow-md">
          <h1 className="font-serif text-3xl text-nm-ink">{title}</h1>
          {subtitle && <p className="text-nm-neutral mt-2 text-sm leading-relaxed">{subtitle}</p>}
          <div className="mt-7">{children}</div>
        </motion.div>
      </div>
    </div>
  );
}

export const inputCls = "w-full rounded-xl border border-nm-primary/15 bg-white px-4 py-3 text-sm text-nm-ink placeholder:text-nm-neutral/50 focus:outline-none focus:ring-2 focus:ring-nm-primary/40 transition-shadow duration-200";
export const btnPrimary = "w-full inline-flex items-center justify-center gap-2 rounded-full bg-nm-coral px-6 py-3 text-sm font-medium text-white hover:brightness-105 disabled:opacity-60 transition-[filter] duration-200";
